export const minimumNaturalNumber = 0;
export const maximumQuantity = 999;

export const maximumOdometer = 1000000; // === 1,000,000.0

export const minimumAmount = 0.0;
export const maximumAmountWithoutVat = 999000000.0; // === 999,000,000.0

export const maximumCommentLength = 255;

export const minimumAge = 18;
export const maximumAge = 69;

export const minPercent = 0.0;
export const maxPercent = 100.0;

export const decimalPlaces = 2;

export const defaultDecimalPlaces = 2;
export const defaultNumericPlaces = 0;
